import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { AddIcon } from "@l2r-front/l2r-icons"
import { LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../constants/i18n"
import {
    ModulesInfo,
    NETWORK_ATTACHMENT,
    ROAD_ATTACHMENT,
    SECTION_ATTACHMENT,
} from "../../constants/modules"

import * as Styled from "./AddDocumentButton.styled"

export function AddDocumentButton(props) {

    const { onAddDocumentMenuSelected } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { road } = useParams()

    return <Styled.MoreMenu
        color="primary"
        icon={AddIcon}
        menuConfig={getMenuConfig(onAddDocumentMenuSelected, road, t)}
    />
}

AddDocumentButton.propTypes = {
    onAddDocumentMenuSelected: PropTypes.func.isRequired,
}

export const getMenuConfig = (onAddDocumentMenuSelected, road, t) => {

    const getIcon = (itemType) => {
        const Icon = ModulesInfo[itemType].icon
        return <Icon color="action/active" />
    }

    return [
        {
            enabled: !road,
            id: `create-${NETWORK_ATTACHMENT}`,
            label: t(I18N_NAMESPACE, "components.addDocumentButton.network"),
            icon: getIcon(NETWORK_ATTACHMENT),
            props: {
                onClick: () => onAddDocumentMenuSelected(NETWORK_ATTACHMENT),
            },
        },
        {
            enabled: true,
            id: `create-${ROAD_ATTACHMENT}`,
            label: t(I18N_NAMESPACE, `components.addDocumentButton.road.${road ? "fromRoad" : "fromNetwork"}`),
            icon: getIcon(ROAD_ATTACHMENT),
            props: {
                onClick: () => onAddDocumentMenuSelected(LINEAR_LOCATION_ROAD),
            },
        },
        {
            enabled: true,
            id: `create-${SECTION_ATTACHMENT}`,
            label: t(I18N_NAMESPACE, "components.addDocumentButton.section"),
            icon: getIcon(SECTION_ATTACHMENT),
            props: {
                onClick: () => onAddDocumentMenuSelected(LINEAR_LOCATION_SECTION),
            },
        },
    ]
}